export const TOGGLE_MENU = 'TOGGLE_MENU';

export function toggleMenu() {
  return {
    type: TOGGLE_MENU,
  };
}



// WEBPACK FOOTER //
// ./src/components/AppHeader/HeaderActions.js